module.exports = __webpack_public_path__ + "48320d8d2ecd5dbc58ae147e37fb38fc.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/bella-ribbed-long-sleeve.png
// module id = 827
// module chunks = 0